import { DEAL_ROUTES, MIP_ROUTES, ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

interface Props {
	investmentWorkflowId?: string;
	documentWorkflowInstanceId?: string;
}

export const useNavigateToMessages = (investorIdArg?: string) => {
	const { mipId, dealId, investorId: investorIdParam } = useParams();

	const investorId = investorIdParam ?? investorIdArg;

	const navigate = useNavigate();

	const navigateToMessages = ({
		investmentWorkflowId,
		documentWorkflowInstanceId,
	}: Props = {}) => {
		if (!investorId || !dealId || !mipId) {
			throw new Error('Missing required parameters');
		}

		const pathname = generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.MIP}${MIP_ROUTES.MESSAGES}`, {
			investorId,
			dealId,
			mipId,
		});

		const searchParams = new URLSearchParams();
		if (investmentWorkflowId) {
			searchParams.set('investmentWorkflowId', investmentWorkflowId);
		}
		if (documentWorkflowInstanceId) {
			searchParams.set('documentWorkflowInstanceId', documentWorkflowInstanceId);
		}

		const search = searchParams.toString() ? `?${searchParams.toString()}` : '';

		navigate({
			pathname,
			search,
		});
	};

	return {
		navigateToMessages,
	};
};
